// extracted by mini-css-extract-plugin
export default {"tooltip":"YR-z","arrow":"ZR-z"};